import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './pages/404/404.component';
import { AgendamentoPsicologosComponent } from './pages/agendamento-psicologos/agendamento-psicologos.component';
import { AtendimentoPsicologosComponent } from './pages/atendimento-psicologos/atendimento.psicologo.component';
import { BuscaComponent } from './pages/busca/busca.component';
import { AdicionarChamadoComponent } from './pages/chamado/adicionar/chamado-add.component';
import { ChamadosListComponent } from './pages/chamado/chamados-list/chamados-list.component';
import { ChamadoUnificadoComponent } from './pages/chamado/chamado-unificado/chamado.unificado.component';
import { DetalheComponent } from './pages/chamado/detalhe/detalhe.component';
import { EditarChamadoComponent } from './pages/chamado/editar/chamado-edit.component';
import { ChamadoComponent } from './pages/chamado/listar/chamado.component';
import { DashboardNaoOcorrenciaComponent } from './pages/dashboard-nao-ocorrencia/dashboard-nao-ocorrencia.component';
import { DashboardReincidenciaComponent } from './pages/dashboard-reincidencia/dashboard-reincidencia.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { RelatorioPecPsicologoComponent } from './pages/pec/pages/relatorio-pec-psicologo/relatorio-pec-psicologo.component';
import { AprocacaoVisitaFiscalComponent } from './pages/fiscal/visitas/aprovacao/aprovacao-visita-fiscal.component';
import { AvailacaoVisitaFiscalComponent } from './pages/fiscal/visitas/avaliacao/availacao-visita-fiscal.component';
import { DashboardVisitasComponent } from './pages/fiscal/visitas/dashboard/dashboard-visitas.component';
import { VisualizarAtividadePsicologoFiscalComponent } from './pages/fiscal/visitas/visualizar/visualizar-atividade.component';
import { FuncionalidadeManageComponent } from './pages/funcionalidade-manage/funcionalidade-manage.component';
import { PageGerenciamentoEmailComponent } from './pages/gerenciamento-email/gerenciamento-email.component';
import { HomeComponent } from './pages/home/home.component';
import { GerenciarLoginComponent } from './pages/login/gerenciar-login/gerenciar-login.component';
import { GerenciarLoginMaspComponent } from './pages/login/gerenciar-login-masp/gerenciar-login-masp.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginMaspComponent } from './pages/login/loginMasp.component';
import { LogoutComponent } from './pages/login/logout/logout.component';
import { MainComponent } from './pages/main/main.component';
import { AddNaoOcorrenciaComponent } from './pages/nao-ocorrencia/adicionar/nao-ocorrencia-add.component';
import { NotificacoesComponent } from './pages/notificacoes/notificacoes.component';
import { PerfilAlunoComponent } from './pages/perfil-aluno/perfil-aluno.component';
import { PerfilManageComponent } from './pages/perfil-manage/perfil-manage.component';
import { PerfilConvivaManageComponent } from './pages/perfil-conviva-manage/perfil-conviva-manage.component';
import { PerfilComponent } from './pages/perfil/perfil.component';
import { PageVisitaProfessorAcolhimentoComponent } from './pages/professor-poc/visitas/acolhimento/professor-visita-acolhemento.component';
import { PageAprocacaoPocVisitasComponent } from './pages/professor-poc/visitas/aprovacao/aprovacao-visitas.component';
import { PageDashboardPocVisitasComponent } from './pages/professor-poc/visitas/dashboard/dashboard-visitas.component';
import { PageVisitaProfessorPrevencaoComponent } from './pages/professor-poc/visitas/prevencao/professor-visita-prevencao.component';
import { PageFiltroVisitasProfessorComponent } from './pages/professor-poc/visitas/professor-filtro-visitas.component';
import { VizualizarAtividadePocComponent } from './pages/professor-poc/visitas/vizualizar/vizualizar-atividade-poc';
import { AdicionarPsicologoComponent } from './pages/psicologo/adicionar/psicologo-add.component';
import { EditarPsicologoComponent } from './pages/psicologo/editar/psicologo-edit.component';
import { ManutencaoPsicologoComponent } from './pages/psicologo/manutencao/psicologo-manutencao.component';
import { VisitaEditarComponent } from './pages/psicologo/visita-editar/visita-editar.component';
import { VisitaPsicologoComponent } from './pages/psicologo/visita/psicologo-visita.component';
import { PageVisitaPsicologoacolhimentoComponent } from './pages/psicologo/visitas/acolhimento/psicologo-visita.acolhimento';
// import { PageInicioAtividadeComponent } from './pages/psicologo/visitas/inicio-atividade/inicio-atividade.component';
import { FuncionalidadesCivico } from './pages/civico-militar/enums/FuncionalidadesCivico';
import { RoleGuard } from './pages/civico-militar/guards/role.guard';
import { FatosService } from './pages/civico-militar/services/fatos.service';
import { AprovacaoAjustePontoComponent } from './pages/psicologo/painel/atividade-psicologo/aprovacao-ajuste-ponto.component.scss/aprovacao-ajuste-ponto.component';
import { PagePainelAtividadesPsicologoComponent } from './pages/psicologo/painel/atividade-psicologo/painel-atividade-psicologo.component';
import { PagePainelAtividadesCoordenadorComponent } from './pages/coordenador-psicologo/atividade-coordenador/painel-atividade-coordenador.component';
import { PageAprovacaoAtividadesPsicologoComponent } from './pages/psicologo/registrar-saida/aprovacao-atividades/aprovacao-atividades.component';
import { PageAprovacaoRegistroComponent } from './pages/psicologo/registrar-saida/aprovacao-registro/aprovacao-registro.component';
import { PageEditarAtividadeComponent } from './pages/psicologo/registrar-saida/editar-atividade/editar-jornada-atividade.component';
import { PageEditarSaidaComponent } from './pages/psicologo/registrar-saida/editar-saida/editar-saida.component';
import { PageRegistroAtividadeComponent } from './pages/psicologo/registrar-saida/registro-atividade/registro-atividade.component';
import { PageRegistroSaidaComponent } from './pages/psicologo/registrar-saida/registro-saida/registro-saida.component';
import { VisualizarJornadaAtividadeComponent } from './pages/psicologo/registrar-saida/visualizar-atividade/visualizar-jornada-atividade.component';
import { AgendamentoPrevencaoComponent } from './pages/psicologo/visitas/agendamento-prevencao/agendamento-prevencao.component';
import { PageAprocacaoVisitasComponent } from './pages/psicologo/visitas/aprovacao/aprovacao-visitas.component';
import { PageDashboardVisitasComponent } from './pages/psicologo/visitas/dashboard/dashboard-visitas.component';
import { DeslocamentoJornadaComponent } from './pages/psicologo/visitas/deslocamento-jornada/deslocamento-jornada.component';
import { PageVisitaPsicologoOutrosComponent } from './pages/psicologo/visitas/outros/psicologo-visita-outros.component';
import { PageVisitaPsicologoPrevencaoComponent } from './pages/psicologo/visitas/prevencao/psicologo-visitas-prevencao.component';
import { PageFiltroVisitasPsicologoComponent } from './pages/psicologo/visitas/psicologo-filtro-visitas.component';
import { VisualizarAtividadeComponent } from './pages/psicologo/visitas/visualizar/visualizar-atividade.component';
import { ConsolidadoComponent } from "./pages/relatorio/consolidado/consolidado.component";
import { DiagnosticoAprovacaoRevertidaComponent } from "./pages/relatorio/diagnostico-aprovacao/diagnostico-aprovacao-revertida.component";
import { PageConsultaPontoComponent } from './pages/relogio-ponto/consulta/consulta-ponto.component';
import { RegistraCheckOutComponent } from './pages/relogio-ponto/registra-check-out/registra-check-out.component';
import { PageTermosUsoDeDadosPessoaisComponent } from './pages/termos-uso-dados-pessoais/termos-uso-dados-pessoais.component';
import { PlanoContingenciaCadastroComponent } from './pages/plano-contingencia/cadastro/plano-contingencia-cadastro.component';
import { PlanoContingenciaConsultaComponent } from './pages/plano-contingencia/consulta/plano-contingencia-consulta.component';
import { HomePecComponent } from './pages/pec/pages/home-pec/home-pec.component';
import { AuthGuardService } from './shared/guards/auth-guard.service';
import { PlanoMelhoriaCadastroComponent } from './pages/plano-melhoria/adicionar/plano-melhoria-cadastro.component';
import { PlanoMelhoriaConsultaComponent } from './pages/plano-melhoria/consultar/plano-melhoria-consulta.component';
import { PlanoMelhoriaCorrecaoVinculoComponent } from './pages/plano-melhoria/correcao-vinculo/plano-melhoria-correcao-vinculo.component';
import { ExtracaoDadosComponent } from './pages/extracao-dados/extracao-dados.component';
import { RelatorioPecComponent } from './pages/professor-poc/relatorio/relatorio-pec.component';
import { FuncoesAdminComponent } from './pages/funcoes-admin/funcoes-admin.component';
import { ParametrosPeriodoComponent } from './pages/parametros-periodo/parametros-periodo.component';
import { CadastroPlanoPeriodoComponent } from './pages/parametros-periodo/cadastro-plano/cadastro-plano-periodo.component';
import { RelatorioAtividadeComponent } from './pages/relatorio/atividade/relatorio-atividade.component';


export const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuardService],
    canActivateChild: [AuthGuardService],
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'home-pec',
        component: HomePecComponent
      },
      {
        path: 'buscar-alunos',
        component: BuscaComponent
      },
      {
        path: 'listar-chamados',
        component: ChamadoComponent,
      },
      {
        path: 'listar-chamados/:ic/:ie',
        component: ChamadoComponent,
      },
      {
        path: 'listar-chamados/:ic/:ie/:di/:es/:an',
        component: ChamadoComponent,
      },
      {
        path: 'chamados-list',
        component: ChamadosListComponent,
      },
      {
        path: 'chamados-unificado-list',
        component: ChamadoUnificadoComponent,
      },
      {
        path: 'cadastrar-chamados/:ra/:te',
        component: AdicionarChamadoComponent,
      },
      {
        path: 'cadastrar-chamados',
        component: AdicionarChamadoComponent
      },
      {
        path: 'agendamento-visita-prevencao',
        component: AgendamentoPrevencaoComponent
      },
      {
        path: 'cadastrar-chamados/:dt',
        component: AdicionarChamadoComponent
      },
      {
        path: 'detalhe/:id',
        component: DetalheComponent
      },
      {
        path: 'editar-chamados/:id',
        component: EditarChamadoComponent
      },
      {
        path: 'perfil',
        component: PerfilComponent
      },
      {
        path: 'notificacoes',
        component: NotificacoesComponent
      },
      {
        path: 'perfil-aluno/:codigoAluno',
        component: PerfilAlunoComponent
      },
      {
        path: 'perfil-aluno/:codigoAluno/:alunoCivicoMilitar',
        component: PerfilAlunoComponent
      },
      {
        path: 'perfil-manage',
        component: PerfilManageComponent
      },
      {
        path: 'perfil-conviva-manage',
        component: PerfilConvivaManageComponent
      },
      {
        path: 'funcionalidade-manage',
        component: FuncionalidadeManageComponent
      },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'dashboard-reincidencia',
        component: DashboardReincidenciaComponent
      },
      {
        path: 'dashboard-nao-ocorrencia',
        component: DashboardNaoOcorrenciaComponent
      },
      {
        path: 'agendamento-psicologos',
        component: AgendamentoPsicologosComponent
      },
      {
        path: 'cadastrar-psicologo',
        component: AdicionarPsicologoComponent
      },
      {
        path: 'manutencao-psicologo',
        component: ManutencaoPsicologoComponent
      },
      {
        path: 'editar-psicologo/:id',
        component: EditarPsicologoComponent
      },
      {
        path: 'atendimento-psicologo',
        component: AtendimentoPsicologosComponent
      },
      {
        path: 'adicionar-nao-ocorrencia',
        component: AddNaoOcorrenciaComponent
      },
      {
        path: 'visita-psicologo',
        component: VisitaPsicologoComponent
      },
      {
        path: 'editar-visita-psicologo',
        component: VisitaEditarComponent
      },
      {
        path: 'dashboard-visitas-psicologo',
        component: PageDashboardVisitasComponent
      },
      {
        path: 'dashboard-visitas-poc',
        component: PageDashboardPocVisitasComponent
      },
      {
        path: 'dashboard-visitas-psicologo-fiscal',
        component: DashboardVisitasComponent
      },
      {
        path: 'visualizar-atividade-psicologo/:id',
        component: VisualizarAtividadeComponent
      },
      {
        path: 'visualizar-atividade-professor-poc/:id',
        component: VizualizarAtividadePocComponent
      },
      {
        path: 'visualizar-atividade-psicologo-fiscal/:id',
        component: VisualizarAtividadePsicologoFiscalComponent
      },
      {
        path: 'filtro-visitas-professor',
        component: PageFiltroVisitasProfessorComponent
      },
      {
        path: 'termos-de-uso-de-dados',
        component: PageTermosUsoDeDadosPessoaisComponent
      },
      {
        path: 'consulta-ponto',
        component: PageConsultaPontoComponent
      },
      {
        path: 'gerenciamento-email',
        component: PageGerenciamentoEmailComponent
      },
      {
        path: 'visita-professor-acolhimento',
        component: PageVisitaProfessorAcolhimentoComponent
      },
      {
        path: 'visita-professor-prevencao',
        component: PageVisitaProfessorPrevencaoComponent
      },
      {
        path: 'filtro-visitas-psicologo',
        component: PageFiltroVisitasPsicologoComponent
      },
      {
        path: 'visita-psicologo-acolhimento/:temDeslocamento',
        component: PageVisitaPsicologoacolhimentoComponent
      },
      {
        path: 'visita-psicologo-prevencao/:temDeslocamento',
        component: PageVisitaPsicologoPrevencaoComponent
      },
      {
        path: 'visita-psicologo-outros/:temDeslocamento',
        component: PageVisitaPsicologoOutrosComponent
      },
      {
        path: 'aprovacao-visitas-psicologo/:id',
        component: PageAprocacaoVisitasComponent
      },
      {
        path: 'aprovacao-visitas-professor-poc/:id',
        component: PageAprocacaoPocVisitasComponent
      },
      {
        path: 'aprovacao-atividade-psicologo-fiscal/:id',
        component: AprocacaoVisitaFiscalComponent
      },
      {
        path: 'consolidado',
        component: ConsolidadoComponent
      },
      {
        path: 'relatorio/diagnostico-aprovacao-revertida',
        component: DiagnosticoAprovacaoRevertidaComponent
      },
      {
        path: 'relatorio-pec-psicologo.component',
        component: RelatorioPecPsicologoComponent
      },
      {
        path: 'avaliacao-visita-fiscal',
        component: AvailacaoVisitaFiscalComponent
      },
      {
        path: 'deslocamento-jornada',
        component: DeslocamentoJornadaComponent
      },
      {
        path: 'registro-saida',
        component: PageRegistroSaidaComponent
      },
      {
        path: 'editar-saida',
        component: PageEditarSaidaComponent
      },
      {
        path: 'registro-saida/adicionar-registro-atividade',
        component: PageRegistroAtividadeComponent
      },
      {
        path: 'registro-saida/editar-registro-atividade',
        component: PageEditarAtividadeComponent
      },
      {
        path: 'registro-saida/jornada',
        component: VisualizarJornadaAtividadeComponent
      },
      {
        path: 'aprovacao-horario-registro-atividades',
        component: PageAprovacaoRegistroComponent
      },
      {
        path: 'painel-atividade-coordenador-psicologo',
        component: PagePainelAtividadesCoordenadorComponent
      }
      ,
      {
        path: 'painel-atividade-psicologo',
        component: PagePainelAtividadesPsicologoComponent
      },
      {
        path: 'registra-check-out',
        component: RegistraCheckOutComponent
      },
      {
        path: 'painel-atividade-psicologo/aprovacao-atividades',
        component: PageAprovacaoAtividadesPsicologoComponent
      },
      {
        path: 'aprovacao-ajuste-ponto',
        component: AprovacaoAjustePontoComponent
      },
      {
        path: 'plano-melhoria/cadastro',
        component: PlanoMelhoriaCadastroComponent
      },
      {
        path: 'plano-melhoria/consulta',
        component: PlanoMelhoriaConsultaComponent
      },
      {
        path: 'plano-melhoria/correcao-vinculo',
        component: PlanoMelhoriaCorrecaoVinculoComponent
      },
      {
        path: 'extracao-dados',
        component: ExtracaoDadosComponent
      },
      {
        path: 'plano-contingencia/cadastro',
        component: PlanoContingenciaCadastroComponent
      },
      {
        path: 'plano-contingencia/consulta',
        component: PlanoContingenciaConsultaComponent
      },
      {
        path: 'relatorio-pec',
        component: RelatorioPecComponent
      },
      {
        path: 'parametros-periodo',
        component: ParametrosPeriodoComponent
      },
      {
        path: 'parametros-periodo/cadastro-plano',
        component: CadastroPlanoPeriodoComponent
      },
      {
        path: 'civico-militar/fato-aluno/atualizar-fatos-nova-resolucao',
        loadComponent: () => import('./pages/civico-militar/pages/fato-aluno/atualizar-fatos-nova-resolucao/atualizar-fatos-nova-resolucao.component').then(m => m.AtualizarFatosNovaResolucaoComponent),
        title: 'Atualizar fatos Cívico Militar'
      },
      {
        path: 'civico-militar',
        canActivateChild: [RoleGuard([
          FuncionalidadesCivico.VisualizarDashboard,
          FuncionalidadesCivico.CadastrarFatoAluno,
          FuncionalidadesCivico.EditarFatoAluno,
          FuncionalidadesCivico.ExcluirFatoAluno
        ])],
        providers: [FatosService],
        runGuardsAndResolvers: 'always',
        loadChildren: () => import('./pages/civico-militar/civico-militar.routes').then(x => x.routesCivicoMilitar)
      },
      {
        path: 'funcoes-admin',
        component: FuncoesAdminComponent
      },
      {
        path: 'relatorio/atividade',
        component: RelatorioAtividadeComponent
      },
    ]
  },
  {
    path: 'gerenciar-login',
    component: GerenciarLoginComponent,
  },
  {
    path: 'gerenciar-login-masp',
    component: GerenciarLoginMaspComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'loginmasp',
    component: LoginMaspComponent,
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: '404',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    redirectTo: ''
  }
];
